<div class="typeahead-wrapper" (click)="openTypeahead()">
  <input
    #instance="ngbTypeahead"
    #element
    class="form-control form-control-lg"
    type="text"
    [required]="props.required"
    [id]="id"
    [formControl]="formControl"
    [class.is-invalid]="(formControl.dirty || formControl.touched) && !formControl.valid"
    [class.is-valid]="(formControl.dirty || formControl.touched) && formControl.valid"
    [focusFirst]="false"
    [inputFormatter]="formatter"
    [ngbTypeahead]="search"
    [placeholder]="placeholder"
    [resultFormatter]="formatter"
    (click)="click$.next($event.target.value.value)"
    (focus)="focus$.next($event.target.value.value)"
    [attr.aria-describedby]="errorId + ' ' + errorDescriptionId"
  />
</div>

<div id="{{ errorDescriptionId }}" class="sr-only">
  {{ valid ? 'valid input' : '' }}
  {{ invalid ? 'invalid input' : '' }}
</div>
